var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "827E467D-BAA5-4278-8958-8BD131507DEB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-175.000000, -1037.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/attention",
    transform: "translate(175.000000, 1037.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4330127,0.250083488 L13.9282032,11.5000835 C14.0662744,11.7392298 13.9843368,12.045025 13.7451905,12.1830962 C13.6691809,12.2269804 13.5829589,12.2500835 13.4951905,12.2500835 L0.504809472,12.2500835 C0.228667097,12.2500835 0.00480947162,12.0262259 0.00480947162,11.7500835 C0.00480947162,11.6623152 0.0279126039,11.5760931 0.0717967697,11.5000835 L6.5669873,0.250083488 C6.70505849,0.0109371759 7.01085369,-0.0710004017 7.25,0.0670707857 C7.3260096,0.110954952 7.38912854,0.174073883 7.4330127,0.250083488 Z",
    id: "Polygon",
    fill: "#FF8000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 6.5,
    y: 3.5,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 6.5,
    y: 9.5,
    width: 1,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.d626dee54f80a8f84d5aa38a46905860.svg";
export { ForwardRef as ReactComponent };